import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { SyncProvider } from './lib/SyncProvider';
import { AtlasProvider } from './lib/store';
import './styles.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <AtlasProvider>
      <SyncProvider>
        <App />
      </SyncProvider>
    </AtlasProvider>
  </StrictMode>,
);
